module.exports = __webpack_public_path__ + "img/bg.02e3a8b5.jpg";